export function buildFormData(params) {
  const formData = new FormData()
  Object.entries(params).forEach(([key, value]) => {
    formData.append(key, value)
  })
  return formData
}